import { arrayMax, arrayMin, Datalayer, IDataLayer, IDatalayerContext, isNumber, labels } from "../omnia"

import m = omnia.models

export class GenplanLayer extends Datalayer {

    private _units: m.GenericPlanUnitId

    constructor(datalayer: IDataLayer, _context: IDatalayerContext) {
        super(datalayer, _context)
    }

    get plan() {
        return this._datalayer.GenericPlan
    }

    get planId() {
        return this._datalayer.GenericPlanId
    }

    get valueUnits() {
        const u = this._units || (this.plan ? this.plan.Units : null)
        return labels.GenericPlanUnitId(u)
    }

    get valueEditTemplate(): string {
        return "app/datalayers/edit/splits/value-numeric-genplan.html"
    }

    setUnits(u: m.GenericPlanUnitId) {
        this._units = u
    }

    getMinMaxRates() {

        const rates = this.zones
            .map(z => z.value)
            .filter(v => isNumber(v))
            .map(v => <Number>v)

        const min = arrayMin(rates, r => r)
        const max = arrayMax(rates, r => r)

        return <[number, number]>[min, max]

    }
}
